module.exports = __webpack_public_path__ + "static/media/LogoEmagrecentro.8c1acd2a.png";